import React, { useState, useEffect } from 'react';
import { ref, onValue, query, limitToLast } from "firebase/database";
import { db } from "../firebaseConfig";
import Navbar from '../components/Navbar';
import { IoThermometerOutline, IoWaterOutline, IoCheckmarkCircleOutline } from "react-icons/io5";
import * as XLSX from 'xlsx'; // Library yang baru Anda install
import './Riwayat.css';

const Riwayat = () => {
  const [historyData, setHistoryData] = useState([]);
  const [activeFilters, setActiveFilters] = useState({
    suhu: '24 Jam',
    ph: '24 Jam',
    kualitas: '24 Jam'
  });

  useEffect(() => {
    // Mengambil 100 data terakhir untuk rekapitulasi
    const historyRef = query(ref(db, 'monitoring_air'), limitToLast(100));
    onValue(historyRef, (snapshot) => {
      const val = snapshot.val();
      if (val) {
        const formattedData = Object.values(val).reverse();
        setHistoryData(formattedData);
      }
    });
  }, []);

  // Fungsi Inti Export Excel
  const downloadExcel = (category) => {
    const fileName = `Rekap_${category}_Agrid_${new Date().toLocaleDateString('id-ID')}.xlsx`;
    
    // Pemetaan data sesuai kategori
    const dataToExport = historyData.map((item, index) => ({
      No: index + 1,
      Waktu: new Date().toLocaleString('id-ID'), 
      'Suhu Air (°C)': item.suhu,
      'pH Air': item.ph <= 1 ? (item.ph * 41.6).toFixed(2) : item.ph,
      'TDS (ppm)': item.tds
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Riwayat Monitoring");
    XLSX.writeFile(workbook, fileName);
  };

  const FilterButtons = ({ category }) => (
    <div className="history-filters">
      {['24 Jam', '1 Minggu', '1 Bulan', '3 Bulan'].map((range) => (
        <button 
          key={range}
          className={activeFilters[category] === range ? 'active' : ''}
          onClick={() => setActiveFilters({...activeFilters, [category]: range})}
        >
          {range}
        </button>
      ))}
    </div>
  );

  return (
    <div className="history-page">
      <Navbar />
      <main className="history-content">
        <div className="history-grid">
          {/* Card Suhu Air */}
          <div className="history-card">
            <IoThermometerOutline className="history-icon" />
            <h3>Data Suhu Air</h3>
            <FilterButtons category="suhu" />
            <button className="btn-unduh" onClick={() => downloadExcel('Suhu')}>
              Unduh Data
            </button>
          </div>

          {/* Card Keasaman Air */}
          <div className="history-card">
            <IoWaterOutline className="history-icon" />
            <h3>Keasaman Air (pH)</h3>
            <FilterButtons category="ph" />
            <button className="btn-unduh" onClick={() => downloadExcel('pH')}>
              Unduh Data
            </button>
          </div>

          {/* Card Kualitas Air */}
          <div className="history-card">
            <IoCheckmarkCircleOutline className="history-icon" />
            <h3>Kualitas Air</h3>
            <FilterButtons category="kualitas" />
            <button className="btn-unduh" onClick={() => downloadExcel('Kualitas')}>
              Unduh Data
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Riwayat;